import { useCart } from '@/context/CartContext';
import { Link } from 'react-router-dom';

export default function CartSidebar() {
  const { items, isOpen, closeCart, removeItem, updateQuantity, total, count } = useCart();

  return (
    <>
      {/* Overlay */}
      <div
        className={`fixed inset-0 bg-black/60 z-[60] transition-opacity duration-300 ${
          isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'
        }`}
        onClick={closeCart}
      />

      {/* Drawer */}
      <aside
        className={`fixed top-0 right-0 h-full w-full sm:w-[420px] bg-white z-[70] flex flex-col transition-transform duration-300 ease-out ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        {/* Header */}
        <div className="bg-[#1A1A1A] px-6 py-4 flex items-center justify-between">
          <h2 className="text-white font-outfit font-semibold text-base">
            Shopping Cart
            {count > 0 && (
              <span className="ml-2 text-[#C4FF61]">({count})</span>
            )}
          </h2>
          <button
            onClick={closeCart}
            className="w-8 h-8 flex items-center justify-center cursor-pointer hover:bg-white/10 rounded-lg transition-colors"
          >
            <i className="ri-close-line text-white text-xl"></i>
          </button>
        </div>

        {/* Cart Items */}
        <div className="flex-1 overflow-y-auto">
          {items.length === 0 ? (
            <div className="flex flex-col items-center justify-center h-full gap-4 px-6">
              <div className="w-16 h-16 flex items-center justify-center">
                <i className="ri-shopping-cart-line text-5xl text-gray-300"></i>
              </div>
              <p className="text-gray-400 font-inter text-sm text-center">
                Your cart is empty.<br />Start adding some gear!
              </p>
              <button
                onClick={closeCart}
                className="mt-2 bg-[#1A1A1A] text-white text-sm font-outfit font-medium px-6 py-3 rounded-full hover:bg-[#2A2A2A] transition-colors cursor-pointer whitespace-nowrap"
              >
                Continue Shopping
              </button>
            </div>
          ) : (
            <ul className="divide-y divide-gray-100">
              {items.map((item) => (
                <li key={item.id} className="flex gap-4 p-5">
                  <Link to={`/product/${item.id}`} onClick={closeCart}>
                    <img
                      src={item.image}
                      alt={item.name}
                      className="w-20 h-20 object-cover object-top rounded-lg flex-shrink-0 cursor-pointer hover:opacity-90 transition-opacity"
                    />
                  </Link>
                  <div className="flex-1 min-w-0">
                    <Link
                      to={`/product/${item.id}`}
                      onClick={closeCart}
                      className="font-outfit font-semibold text-sm text-[#1A1A1A] leading-snug hover:text-[#1A1A1A]/70 transition-colors cursor-pointer block truncate"
                    >
                      {item.name}
                    </Link>
                    <p className="text-xs text-gray-400 font-inter mt-0.5">{item.category}</p>
                    <p className="text-sm font-outfit font-bold text-[#1A1A1A] mt-1">
                      ${item.price.toFixed(2)}
                    </p>
                    <div className="flex items-center gap-2 mt-2">
                      <div className="flex items-center border border-gray-200 rounded-lg overflow-hidden">
                        <button
                          onClick={() => updateQuantity(item.id, item.quantity - 1)}
                          className="w-7 h-7 flex items-center justify-center text-gray-500 hover:bg-gray-50 transition-colors cursor-pointer"
                        >
                          <i className="ri-subtract-line text-xs"></i>
                        </button>
                        <span className="w-8 text-center text-sm font-outfit font-medium text-[#1A1A1A]">
                          {item.quantity}
                        </span>
                        <button
                          onClick={() => updateQuantity(item.id, item.quantity + 1)}
                          className="w-7 h-7 flex items-center justify-center text-gray-500 hover:bg-gray-50 transition-colors cursor-pointer"
                        >
                          <i className="ri-add-line text-xs"></i>
                        </button>
                      </div>
                      <button
                        onClick={() => removeItem(item.id)}
                        className="text-xs text-gray-400 hover:text-red-500 font-inter transition-colors cursor-pointer whitespace-nowrap"
                      >
                        Remove
                      </button>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>

        {/* Footer */}
        {items.length > 0 && (
          <div className="border-t border-gray-100 p-6 bg-[#F7F8F9]">
            <div className="flex justify-between items-center mb-2">
              <span className="text-sm text-gray-500 font-inter">Subtotal</span>
              <span className="text-sm font-outfit font-medium text-[#1A1A1A]">${total.toFixed(2)}</span>
            </div>
            <div className="flex justify-between items-center mb-1">
              <span className="text-xs text-gray-400 font-inter">Shipping</span>
              <span className="text-xs text-gray-400 font-inter">Calculated at checkout</span>
            </div>
            <div className="flex justify-between items-center mt-3 mb-5">
              <span className="font-outfit font-bold text-[#1A1A1A]">Total</span>
              <span className="font-outfit font-bold text-xl text-[#1A1A1A]">${total.toFixed(2)}</span>
            </div>
            <button className="w-full bg-[#C4FF61] text-[#1A1A1A] font-outfit font-bold py-4 rounded-full flex items-center justify-center gap-2 hover:bg-[#a8e84a] transition-colors cursor-pointer whitespace-nowrap text-sm">
              <i className="ri-lock-line"></i>
              Proceed to Checkout
            </button>
            <button
              onClick={closeCart}
              className="w-full mt-3 text-center text-sm text-gray-400 hover:text-[#1A1A1A] font-inter transition-colors cursor-pointer whitespace-nowrap py-1"
            >
              Continue Shopping
            </button>
          </div>
        )}
      </aside>
    </>
  );
}
